<template>
  <div class="flex justify-start items-end mr-4">
    <div class="footer-item__container">
      <div :class="{ featured }">
        {{ line1 }}
      </div>
      <div>{{ line2 }}</div>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'FooterItem',

  props: {
    line1: {
      type: String,
      default: '',
    },

    line2: {
      type: String,
      default: '',
    },

    featured: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="postcss" scoped>
.footer-item {
  &__container {
    font-family: 'input-mono';
    font-size: 12px;
    @apply text-blue h-full flex flex-col justify-end items-end mr-4;

    & > * {
      @apply mb-1;
    }
  }
}
.featured {
  @apply text-blue-lighter bg-blue p-1;
}
</style>
